export default "/static/webpack/media/undraw_drag.b5c56966.svg";